import React, { useState } from "react";
import { useForm } from "react-hook-form";
import TableFixedPage from "../../TableFixedPage/TableFixedPage";
import Style from "./AddNewCategoryContainer.module.scss";
import Resizer from "react-image-file-resizer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import {
  AddmarketCategoryAPI,
  getSupermarketCategoryApi,
} from "../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import Select from "react-select";
import { useEffect } from "react";

const AddNewCategoryContainer = () => {
  const [categoryLevelOne, setCategoryLevelOne] = useState(true);
  const [photo, setPhoto] = useState("");
  const [onChangeCat1, setOnChangeCat1] = useState(false);
  const [disable, setDisable] = useState(false);
  const [disableLevelTwo, setDisableLevelTwo] = useState(false);
  const [categoryId, setcategoryId] = useState();
  const [supermarketCategory, setSupermarketCategory] = useState([]);
  useEffect(() => {
    getCategory();
  }, []);
  //////validation input //////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const chooseLevel = (e) => {
    if (e.target.value === "one") {
      setCategoryLevelOne(true);
    } else if (e.target.value === "two") {
      setCategoryLevelOne(false);
    }
  };
  ////get market category/////////
  const getCategory = async () => {
    getSupermarketCategoryApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSupermarketCategory(res.category);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  let categoryOption =
    supermarketCategory &&
    supermarketCategory.map((item) => {
      return { value: item.id, label: item.category, parent: item.parent };
    });
  let categoryFirst = [];
  categoryOption.forEach((val) => {
    if (val.parent === "2") {
      categoryFirst.push(val);
    }
  });
  const getCategory1OnChange = (e) => {
    setOnChangeCat1(true);
    setcategoryId(e.value);
  };
  //////آپلود کردن عکس
  const UploadPhoto = async (image) => {
    return await resizeFileLogo(image);
  };
  /////ریسایز کردن logo برای آپلود
  const resizeFileLogo = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setPhoto(uri);
        },
        "base64"
      );
    });
  const onsubmit = (data) => {
    setDisable(true)
    let info = {
      parent: "",
      category_english: data.english,
      category_persian: data.persian,
      category_fee: "",
      photo: photo,
    };
    AddmarketCategoryAPI(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت افزوده شد");
        setDisable(false)
      } else {
        errorToast("متاسفانه مشکلی بوجود آمد");
        setDisable(false)
      }
    });
  };
  const onsubmitLeveltwo = (data) => {
    setDisableLevelTwo(true)
    let info = {
      parent: categoryId,
      category_english: data.englishTwo,
      category_persian: data.persianTwo,
      category_fee: data.karmozd,
      photo: "",
    };
    AddmarketCategoryAPI(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت افزوده شد");
        setDisableLevelTwo(false)
      } else {
        errorToast(res.message);
        setDisableLevelTwo(false)
      }
    });
  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"افزودن دسته بندی فروشگاه"} />
      <select className={Style.selectHolder} onChange={chooseLevel}>
        <option className={Style.option} value={"one"}>
          دسته بندی سطح اول
        </option>
        <option className={Style.option} value={"two"}>
          دسته بندی سطح دوم
        </option>
      </select>
      {categoryLevelOne ? (
        <div className={Style.formPart}>
          <form onSubmit={handleSubmit(onsubmit)} className={Style.levelOne}>
            <section className={Style.logoPart}>
              {/* <div className={Style.titleLogo}>بارگذاری تصویر</div> */}
              <div className={Style.uploadImage}>
                <img
                  src={photo ? photo : "/Assets/Images/UploadImage/upload.png"}
                  alt=""
                />
              </div>
              <input
                id={"uploadPhoto"}
                type="file"
                style={{ display: "none" }}
                onChange={(e) => UploadPhoto(e.target.files[0])}
              />
              <div className={Style.loadImagPart}>
                <label htmlFor={"uploadPhoto"} className={Style.iconHolder}>
                  <FontAwesomeIcon className={Style.icon} icon={faImage} />
                </label>
                <h3 className={Style.textLogo}>بارگذاری تصویر</h3>
              </div>
            </section>
            <input
              {...register("persian", { required: true })}
              className={errors.persian ? Style.inputError : Style.inputPart}
              placeholder="نام دسته بندی به فارسی"
            />
            <input
              {...register("english", { required: true })}
              className={errors.english ? Style.inputError : Style.inputPart}
              placeholder="نام دسته بندی به انگلیسی"
            />
            <div className={Style.btnHolder}>
              <button type="submit" className={Style.addBtn} disabled={disable}>
                افزودن
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className={Style.formPart}>
          <form
            onSubmit={handleSubmit(onsubmitLeveltwo)}
            className={Style.levelOne}
          >
            <Select
              onChange={(e) => getCategory1OnChange(e)}
              options={categoryFirst}
              value={categoryFirst.filter(
                (option) => option.value === categoryId
              )}
              className={Style.selectOptionsearch}
              placeholder={"دسته بندی اول"}
            />
            <input
              {...register("persianTwo", { required: true })}
              className={errors.persianTwo ? Style.inputError : Style.inputPart}
              placeholder="نام دسته بندی به فارسی"
            />
            <input
              {...register("englishTwo", { required: true })}
              className={errors.englishTwo ? Style.inputError : Style.inputPart}
              placeholder="نام دسته بندی به انگلیسی"
            />
            <input
              {...register("karmozd", { required: true })}
              className={errors.karmozd ? Style.inputError : Style.inputPart}
              placeholder="کارمزد این دسته بندی عدد بین 0 و 100"
            />
            <div className={Style.btnHolder}>
              <button type="submit" className={Style.addBtn} disabled={disableLevelTwo}>
                افزودن
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default AddNewCategoryContainer;
